// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainDialog {
  display: flex;
  flex-direction: column;
  padding: 1rem;
}
.mainDialog .header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.mainDialog .header > p {
  font-size: 1.2rem;
}
.mainDialog .gridItemContainer {
  padding: 0.75rem;
  border-radius: 1rem;
  border: 1px solid #DCDFE1;
  min-width: 232px;
}
.mainDialog .gridItemContainer .title {
  font-size: 1rem;
  font-weight: bold;
}
.mainDialog .gridItemContainer .head {
  margin: 0.5rem auto;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.mainDialog .gridItemContainer .gridItemContent {
  margin-top: 0.3rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #F4F5F7;
  border-radius: 0.6rem;
  text-align: center;
  padding: 0.3rem 0.3rem 0.3rem 0.5rem;
}
.mainDialog .gridItemContainer .gridItemContent > :first-child {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.1rem;
}
.mainDialog .gridItemContainer .gridItemContent > :last-child {
  min-width: 35px;
}
.mainDialog .gridItemContainer .gridItemContent .title {
  font-size: 0.6rem;
  display: inline-block;
  min-width: 65px;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
  line-height: 0.6rem;
  text-align: right;
}
.mainDialog .gridItemContainer .gridItemContent .square {
  width: 12px;
  height: 12px;
  border-radius: 0.1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/ResutTest/Clifton/Dialog/clifton.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;AACJ;AACI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AACR;AAEI;EACI,iBAAA;AAAR;AAGI;EACI,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AADR;AAGQ;EACI,eAAA;EACA,iBAAA;AADZ;AAIQ;EACI,mBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAFZ;AAKQ;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,oCAAA;AAHZ;AAKY;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAHhB;AAMY;EACI,eAAA;AAJhB;AAQY;EACI,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AANhB;AASY;EACI,WAAA;EACA,YAAA;EACA,qBAAA;AAPhB","sourcesContent":[".mainDialog {\n    display: flex;\n    flex-direction: column;\n    padding: 1rem;\n\n    .header {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    .header>p {\n        font-size: 1.2rem;\n    }\n\n    .gridItemContainer {\n        padding: 0.75rem;\n        border-radius: 1rem;\n        border: 1px solid #DCDFE1;\n        min-width: 232px;\n\n        .title {\n            font-size: 1rem;\n            font-weight: bold;\n        }\n\n        .head {\n            margin: 0.5rem auto;\n            width: 100%;\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n        }\n\n        .gridItemContent {\n            margin-top: 0.3rem;\n            width: 100%;\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            background-color: #F4F5F7;\n            border-radius: 0.6rem;\n            text-align: center;\n            padding: 0.3rem 0.3rem 0.3rem 0.5rem;\n\n            >:first-child {\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                gap: 0.1rem;\n            }\n\n            >:last-child {\n                min-width: 35px;\n            }\n\n\n            .title {\n                font-size: 0.6rem;\n                display: inline-block;\n                min-width: 65px;\n                white-space: nowrap;\n                overflow: hidden !important;\n                text-overflow: ellipsis;\n                line-height: 0.6rem;\n                text-align: right;\n            }\n\n            .square {\n                width: 12px;\n                height: 12px;\n                border-radius: 0.1rem;\n            }\n        }\n\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
